<template>
  <div
    style="margin-top: 10%"
    class="animated fadeIn d-flex flex-column align-items-center justify-content-center"
    v-if="isLoading"
  >
    <div v-if="isLoading && isLoading !== true" style="margin-bottom: 16px">
      <h2>{{ isLoading }}</h2>
    </div>
    <div
      style="width: 10rem; height: 10rem"
      class="spinner-border text-primary"
      role="status"
    >
      <span class="sr-only">Loading...</span>
    </div>
  </div>
  <section v-else class="w-100 animated fadeIn" id="tables">
    <mdb-modal
      size="md"
      :show="showModalDelete"
      :centered="true"
      @close="
        () => {
          itemLaunch = null;
          showModalDelete = false;
        }
      "
    >
      <mdb-modal-header>
        <mdb-modal-title>Deletar campanha</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        Tem certeza que deseja deletar a campanha?
      </mdb-modal-body>
      <mdb-modal-footer>
        <mdb-btn
          color="secondary"
          @click.native="
            () => {
              showModalDelete = false;
            }
          "
          >Não</mdb-btn
        >
        <mdb-btn
          color="primary"
          @click.native="
            () => {
              deleteCampaign();
            }
          "
          >Sim</mdb-btn
        >
      </mdb-modal-footer>
    </mdb-modal>
    <mdb-modal
      size="md"
      :show="showModalLaunch"
      :centered="true"
      @close="
        () => {
          itemLaunch = null;
          showModalLaunch = false;
        }
      "
    >
      <mdb-modal-header>
        <mdb-modal-title>Disparar campanha</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        Tem certeza que deseja disparar a campanha?
      </mdb-modal-body>
      <mdb-modal-footer>
        <mdb-btn
          color="secondary"
          @click.native="
            () => {
              showModalLaunch = false;
            }
          "
          >Não</mdb-btn
        >
        <mdb-btn
          color="primary"
          @click.native="
            () => {
              launchCampaign();
            }
          "
          >Sim</mdb-btn
        >
      </mdb-modal-footer>
    </mdb-modal>

    <mdb-row class="mt-4">
      <mdb-col>
        <mdb-btn
          class="btn btn-rounded m-0 mb-2 float-right"
          color="blue-grey"
          @click.native="
            () => {
              clearData();
              showModalAdd = true;
            }
          "
        >
          Salvar Campanha
        </mdb-btn>

        <div class="d-flex justify-content-between flex-wrap">
          <form @submit.prevent class="d-flex align-items-center mr-5">
            <mdb-icon icon="search" class="mr-3" />

            <mdb-input
              style="width: 210px"
              class="m-0"
              type="text"
              v-model="inputSearch"
              placeholder="Digite o texto para filtrar"
            />
          </form>
        </div>
        <div class="w-100 d-flex flex-column align-items-center">
          <mdb-tbl responsive hover bordered class="w-100 text-center">
            <colgroup>
              <col :span="columns.length" />
              <col style="width: 175px" />
            </colgroup>
            <thead class="bg-color-table">
              <tr class="text-white">
                <th v-for="column in columns" :key="column">
                  {{ column }}
                  <mdb-icon
                    v-if="
                      [
                        'Nome da campanha',
                        'Falecido',
                        'Tipo',
                        'Gênero',
                        'Documento',
                        'Idade',
                      ].includes(column)
                    "
                    @click.native="handleSort(column)"
                    style="cursor: pointer; margin-left: 4px"
                    icon="sort"
                  />
                </th>
                <th>Ação</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bordered"
                :style="
                  item.currentCampaign
                    ? 'background-color:rgb(127, 145, 153);'
                    : ''
                "
                v-for="(item, index) in data"
                :key="index"
              >
                <td>
                  <span
                    class="first-text font-weight-bold"
                    :style="rowStyle(item)"
                  >
                    {{ item.name }}
                  </span>
                </td>
                <td>
                  <span
                    class="first-text font-weight-bold"
                    :style="rowStyle(item)"
                  >
                    {{ item.totalOfOpportunities }}
                  </span>
                </td>
                <td>
                  <span
                    class="first-text font-weight-bold"
                    :style="rowStyle(item)"
                  >
                    {{ item.contactMade }}
                  </span>
                </td>
                <td>
                  <span
                    class="first-text font-weight-bold"
                    :style="rowStyle(item)"
                  >
                    {{ item.noContactReturn }}
                  </span>
                </td>
                <td>
                  <span
                    class="first-text font-weight-bold"
                    :style="rowStyle(item)"
                  >
                    {{ item.thereWasNoContact }}
                  </span>
                </td>
                <td>
                  <span
                    class="first-text font-weight-bold"
                    :style="rowStyle(item)"
                  >
                    {{ item.notInterested }}
                  </span>
                </td>
                <td>
                  <span
                    class="first-text font-weight-bold"
                    :style="rowStyle(item)"
                  >
                    {{ item.hasInterest }}
                  </span>
                </td>
                <td class="pt-1">
                  <span class="first-text font-weight-bold">
                    <div
                      class="d-flex justify-content-evenly"
                      style="font-size: 10px"
                    >
                      <div class="d-flex flex-column justify-content-center">
                        <span :style="rowStyle(item)">Extrair Relatório</span>
                        <mdb-btn
                          title="Extrair Relatório"
                          type="button"
                          class="btn btn-blue btn-rounded btn-sm m-0 text-btn"
                          @click.native="
                            () => {
                              downloadCampaign(item);
                            }
                          "
                        >
                          <mdb-icon icon="file-alt" />
                        </mdb-btn>
                      </div>
                      <div class="d-flex flex-column justify-content-center">
                        <span :style="rowStyle(item)" class="ml-3"
                          >Visualizar Dados</span
                        >
                        <mdb-btn
                          title="Visualizar"
                          type="button"
                          class="btn btn-blue btn-rounded btn-sm m-0 ml-3 text-btn"
                          @click.native="
                            () => {
                              viewCampaign(item);
                            }
                          "
                        >
                          <mdb-icon icon="eye" />
                        </mdb-btn>
                      </div>
                      <div class="d-flex flex-column justify-content-center">
                        <span :style="rowStyle(item)" class="ml-3"
                          >Disparar Campanha</span
                        >
                        <mdb-btn
                          title="Disparar Campanha"
                          type="button"
                          class="btn btn-blue btn-rounded btn-sm m-0 ml-3 text-btn"
                          @click.native="
                            () => {
                              itemLaunch = item;
                              showModalLaunch = true;
                            }
                          "
                        >
                          <mdb-icon icon="rocket" />
                        </mdb-btn>
                      </div>
                      <div class="d-flex flex-column justify-content-center">
                        <span :style="rowStyle(item)" class="ml-3"
                          >Deletar Campanha</span
                        >
                        <mdb-btn
                          title="Deletar"
                          type="button"
                          class="btn btn-blue btn-rounded btn-sm m-0 ml-3 text-btn"
                          @click.native="
                            () => {
                              itemLaunch = item;
                              showModalDelete = true;
                            }
                          "
                        >
                          <mdb-icon icon="trash" />
                        </mdb-btn>
                      </div>
                    </div>
                  </span>
                </td>
              </tr>
            </tbody>
          </mdb-tbl>
          <mdb-pagination lg>
            <!-- <mdb-page-item :disabled="page == 1 ? true : false">Primeiro</mdb-page-item> -->
            <mdb-page-nav :disabled="page == 1 ? true : false"></mdb-page-nav>
            <mdb-page-item
              @click.native="alterPage(n)"
              v-for="n in totalPages"
              :key="n"
              :active="page == n ? true : false"
              >{{ n }}</mdb-page-item
            >
            <mdb-page-nav></mdb-page-nav>
            <!-- <mdb-page-item>Último</mdb-page-item> -->
          </mdb-pagination>
        </div>
      </mdb-col>
    </mdb-row>
    <!-- EDIT MODAL -->
    <portal to="notification-outlet">
      <mdb-modal size="lg" :show="showModalEdit" @close="showModalEdit = false">
        <mdb-modal-header>
          <mdb-modal-title>Editar Campanha</mdb-modal-title>
        </mdb-modal-header>
        <mdb-modal-body>
          <form @submit.prevent="handleUpdate">
            <div class="grey-text p-3">
              <div class="w-100 input-wrapper">
                <label for="name" class="mt-3 grey-text"
                  >Nome da Campanha</label
                >
                <input
                  v-model="itemEdit.name"
                  type="text"
                  id="name"
                  class="form-control"
                  required
                />
              </div>

              <div class="modal-line">
                <div class="input-wrapper">
                  <label for="Date" class="mt-3">Data de Início</label>
                  <datepicker
                    v-model="itemEdit.start_at"
                    id="Date"
                    bootstrap-styling
                    name="Date"
                    bg
                    :language="ptBR"
                    label="Date"
                    required
                  />
                </div>
                <div class="input-wrapper">
                  <label for="EndDate" class="mt-3">Data Finalização</label>
                  <datepicker
                    v-model="itemEdit.finish_at"
                    id="EndDate"
                    bootstrap-styling
                    name="EndDate"
                    bg
                    :language="ptBR"
                    label="EndDate"
                    required
                  />
                </div>
              </div>
              <div class="mt-3 float-right">
                <mdb-btn color="danger" @click.native="showModalEdit = false"
                  >Cancelar</mdb-btn
                >
                <mdb-btn type="submit" color="primary">Editar</mdb-btn>
              </div>
            </div>
          </form>
        </mdb-modal-body>
      </mdb-modal>
    </portal>
    <portal to="notification-outlet">
      <mdb-modal size="xl" :show="showModalAdd" @close="showModalAdd = false">
        <mdb-modal-header>
          <mdb-modal-title>Salvar Campanha</mdb-modal-title>
        </mdb-modal-header>
        <mdb-modal-body>
          <form @submit.prevent="handleSubmit">
            <div class="d-flex">
              <div
                class="d-flex flex-column justify-content-between flex-grow-1 w-100 grey-text p-3 m-0"
              >
                <div class="w-100 input-wrapper">
                  <label for="name" class="mt-3 grey-text"
                    >Nome da Campanha</label
                  >
                  <input
                    v-model="name"
                    type="text"
                    id="name"
                    class="form-control"
                    required
                  />
                </div>
                <div class="w-100 input-wrapper">
                  <div class="row-label">
                    <label>Número do Whatsapp</label>
                    <label>Template</label>
                  </div>
                  <div
                    v-for="(element, index) in collection"
                    :key="index"
                    class="d-flex w-100"
                    style="column-gap: 3em"
                  >
                    <v-select
                      :options="numbers"
                      class="flex-fill w-100"
                      v-model="element.selectedNumber"
                      @input="() => getTemplates(element.selectedNumber)"
                      :rules="[(v) => !!v || 'Número é obrigatório']"
                      required
                    >
                      <template #search="{ attributes, events }">
                        <input
                          class="vs__search"
                          :required="!element.selectedNumber"
                          v-bind="attributes"
                          v-on="events"
                        />
                      </template>
                    </v-select>
                    <v-select
                      :options="
                        element.selectedNumber &&
                        templatesByIdentifier[element.selectedNumber.value]
                          ? templatesByIdentifier[
                              element.selectedNumber.value
                            ].reduce((acc, el) => {
                              if (!acc.includes(el.name)) {
                                acc.push(el.name);
                              }
                              return acc;
                            }, [])
                          : []
                      "
                      class="flex-fill w-100"
                      :disabled="loadingTemplate"
                      v-model="element.selectedName"
                      @input="() => initPreview()"
                      required
                    >
                      <template #search="{ attributes, events }">
                        <input
                          class="vs__search"
                          :required="!element.selectedName"
                          v-bind="attributes"
                          v-on="events"
                        />
                      </template>
                    </v-select>
                  </div>
                  <mdb-btn
                    color="primary"
                    class="w-100 m-0 mt-0 mt-2 p-2"
                    style="font-size: 1rem"
                    @click="addGroup"
                    :disabled="disabledAddGroup"
                    >+</mdb-btn
                  >
                </div>

                <div class="d-flex mt-4 gap-3 groupbuttons">
                  <mdb-btn
                    class="flex-fill m-0 p-4"
                    color="danger"
                    @click.native="showModalAdd = false"
                    >Cancelar</mdb-btn
                  >
                  <mdb-btn class="flex-fill m-0" type="submit" color="primary"
                    >Salvar</mdb-btn
                  >
                </div>
              </div>

              <div
                class="flex-fill mb-3 position-relative"
                style="max-height: 525px; overflow: hidden"
              >
                <div
                  style="width: 2rem; height: 2rem"
                  class="d-flex align-self-center position-absolute custom-absolute-positioning spinner-border text-primary"
                  role="status"
                  v-if="loadingPreview"
                ></div>
                <div
                  class="d-flex align-self-center position-absolute custom-absolute-positioning"
                  v-if="
                    collection[collection.length - 1].selectedNumber &&
                    loadingPreview == false
                  "
                >
                  <div class="whatsapp-container">
                    <div class="whatsapp-body">
                      <div class="whatsapp-message-body">
                        {{ this.selectedTemplateBody }}
                      </div>
                    </div>
                    <div class="whatsapp-buttons-group">
                      <div
                        class="whatsapp-button"
                        v-for="(button, index) in selectedTemplateButtons"
                        :key="index"
                      >
                        {{ button }}
                      </div>
                    </div>
                  </div>
                </div>
                <img
                  class="img-fluid"
                  src="../../assets/wallpaper-whatsapp.jpg"
                  style="min-width: 100%; min-height: 100%; object-fit: cover"
                />
              </div>
            </div>
          </form>
        </mdb-modal-body>
      </mdb-modal>
    </portal>
  </section>
</template>

<script>
import {
  mdbRow,
  mdbCol,
  mdbTbl,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter,
  mdbPagination,
  mdbPageItem,
  mdbPageNav,
  mdbBtn,
  mdbIcon,
  mdbInput,
} from "mdbvue";

import { ptBR } from "vuejs-datepicker/dist/locale";
import Datepicker from "vuejs-datepicker";
import {
  getCampaigns,
  updateCampaigns,
  createTemplateCollection,
  deleteCampaign,
  launchCampaign,
  downloadCampaign,
} from "../../services/Campaign";
import {
  listCredentials,
  listTemplates,
  listTemplateDetails,
} from "../../services/Auth";
export default {
  name: "Campaign",
  components: {
    mdbInput,
    mdbRow,
    mdbCol,
    mdbTbl,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbBtn,
    Datepicker,
    mdbPagination,
    mdbPageItem,
    mdbPageNav,
    mdbIcon,
  },
  computed: {
    templates() {
      // remove and clean array to be unique
      return (this.templatesData || []).reduce((acc, el) => {
        if (!acc.includes(el.name)) {
          acc.push(el.name);
        }
        return acc;
      }, []);
    },
    disabledAddGroup() {
      const lastCollection = this.collection[this.collection.length - 1];
      return !lastCollection.selectedName || !lastCollection.selectedNumber;
    },
  },

  data() {
    return {
      campaignView: false,
      sort: true,
      showModalAdd: false,
      showModalEdit: false,
      name: "",
      description: "",
      isDead: "",
      startDate: new Date(),
      endDate: new Date(),
      linkCampaign: "",
      candidates: 1,
      itemEdit: {},
      itemToUpdate: {},
      type: "",
      typeOptions: ["", "Aposentado", "Pensionista"],
      gender: "",
      genderOptions: ["", "Masculino", "Feminino"],
      isDeadOptions: ["", "Sim", "Não"],
      document: "",
      age: "",
      columns: [
        "Nome da campanha",
        "Total de oportunidades",
        "Contatos realizados",
        "Sem retorno de contato",
        "Não houve contato",
        "Não tem interesse",
        "Contato tem interesse",
      ],
      isLoading: false,
      data: [],
      dataBkp: [],
      dataSearch: [],
      dataOrder: [],
      inputSearch: "",
      limit: 20,
      page: 1,
      totalPages: 0,
      order: true,
      showModalLaunch: false,
      showModalDelete: false,
      itemLaunch: null,
      ptBR,
      credentials: [],
      selectedTemplateBody: "",
      selectedTemplateButtons: [],
      selectedTemplateIdentifier: "",
      loadingTemplate: false,
      loadingPreview: false,
      templatesData: [],
      selectedName: "",
      selectedNumber: "",
      collection: [{}],
      numbers: [],
      indexCollection: 0,
      templatesByIdentifier: {},
    };
  },

  created() {
    listCredentials()
      .then((data) => {
        this.credentials = data;
        if (data.length) {
          // remove and clean array to be unique
          this.numbers = (data || []).reduce((acc, el) => {
            if (!acc.includes(el.numero_whatsapp)) {
              acc.push({ label: el.numero_whatsapp, value: el.identificador });
            }
            return acc;
          }, []);
        }
      })
      .catch(() => {
        this.$toast.open({
          position: "top",
          message:
            "Ops, aconteceu um erro ao buscar as credenciais para o usuário atual! Tente novamente com outro usuário!",
          type: "error",
        });
      });
  },
  mounted() {
    this.renderComponent();
  },
  watch: {
    inputSearch() {
      const filtered = this.dataBkp.filter(this.filterCampaign);
      this.page = 1;
      this.totalPages = parseInt(Math.ceil(filtered.length / this.limit));
      this.data = this.paginate(filtered, this.limit, this.page);
    },
  },
  methods: {
    addGroup() {
      this.collection = [...this.collection, {}];
      // this.collection.push({});
    },

    getTemplates(selectedNumber) {
      if (!selectedNumber || !selectedNumber.value) {
        return [];
      }
      // if (!this.templatesByIdentifier[selectedNumber.value])
      this.loadingTemplate = true;
      this.loadingPreview = true;
      document.body.style.cursor = "progress";

      listTemplates(selectedNumber.value)
        .then((data) => {
          if (data.length) {
            this.$set(this.templatesByIdentifier, selectedNumber.value, data);
            // templatesByIdentifier[selectedNumber.value] = data;
            // element.selectedName = data[0].name;
            return (
              this.templatesByIdentifier[selectedNumber.value] || []
            ).reduce((acc, el) => {
              if (!acc.includes(el.name)) {
                acc.push(el.name);
              }
              return acc;
            }, []);
          }
        })
        .catch(() => {
          this.$toast.open({
            position: "top",
            message:
              "Ops, aconteceu um erro ao buscar os templates para o número selecionado! Tente novamente com outro número!",
            type: "error",
          });
        })
        .finally(() => {
          document.body.style.cursor = "auto";
          this.loadingTemplate = false;
        });
    },

    initPreview() {
      const lastCollection = this.collection[this.collection.length - 1];
      this.loadingPreview = true;
      console.log(
        this.templatesByIdentifier[lastCollection.selectedNumber.value].find(
          (el) => el.name == lastCollection.selectedName
        )._id
      );
      listTemplateDetails({
        identifier: lastCollection.selectedNumber.value,
        template_id: this.templatesByIdentifier[
          lastCollection.selectedNumber.value
        ].find((el) => el.name == lastCollection.selectedName)._id,
      })
        .then((data) => {
          if (data.length) {
            this.selectedTemplateBody = data[0].sample_text;
            this.selectedTemplateButtons = data[0].sample_buttons;
          }
        })
        .catch(() => {
          this.$toast.open({
            position: "top",
            message:
              "Ops, aconteceu um erro ao buscar a visualização do template escolhido para o número selecionado! Tente novamente com outro número!",
            type: "error",
          });
        })
        .finally(() => {
          document.body.style.cursor = "auto";
          this.loadingPreview = false;
        });
    },

    filterCampaign(campaign) {
      return campaign.name
        .toLowerCase()
        .includes(this.inputSearch.toLowerCase());
    },
    rowStyle(item) {
      return item.currentCampaign ? "color:white" : "";
    },
    downloadCampaign(itemC) {
      const item = itemC;
      this.isLoading = "Extraindo Relatório";
      downloadCampaign(item)
        .then((data) => {
          const url = window.URL.createObjectURL(new Blob([data])); // you can mention a type if you wish
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `relatorio-${item.name}-${new Date()}.xlsx`
          ); //this is the name with which the file will be downloaded
          link.click();
          // no need to append link as child to body.
          setTimeout(() => window.URL.revokeObjectURL(url), 0); // this is important too, otherwise we will be unnecessarily spiking memory!

          this.$toast.open({
            position: "top",
            message: "Relatório extraído com sucesso!",
            type: "success",
          });
        })
        .catch(() => {
          this.$toast.open({
            position: "top",
            message:
              "Ops, aconteceu um erro ao extrair o relatório! Tente mais tarde!",
            type: "error",
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    viewCampaign(item) {
      this.campaignView = item;
      const { _id: id } = item;
      this.$router.push(`/campaign/${id}`);
    },
    launchCampaign() {
      const item = this.itemLaunch;
      this.isLoading = "Disparando campanha";
      launchCampaign(item)
        .then(() => {
          this.renderComponent();
          this.$toast.open({
            position: "top",
            message: "Campanha disparada com sucesso!",
            type: "success",
          });
        })
        .catch(() => {
          this.$toast.open({
            position: "top",
            message:
              "Ops, aconteceu um erro ao disparar sua campanha! Tente mais tarde!",
            type: "error",
          });
        })
        .finally(() => {
          this.isLoading = false;
          this.itemLaunch = null;
          this.showModalLaunch = false;
        });
    },
    deleteCampaign() {
      const item = this.itemLaunch;
      this.isLoading = "Deletando a campanha";
      deleteCampaign(item)
        .then(() => {
          this.renderComponent();

          this.$toast.open({
            position: "top",
            message: "Campanha deletada com sucesso!",
            type: "success",
          });
        })
        .catch(() => {
          this.$toast.open({
            position: "top",
            message:
              "Ops, aconteceu um erro ao deletar sua campanha! Tente mais tarde!",
            type: "error",
          });
        })
        .finally(() => {
          this.isLoading = false;
          this.itemLaunch = null;
          this.showModalDelete = false;
        });
    },
    renderComponent() {
      this.isLoading = true;
      getCampaigns().then((res) => {
        this.isLoading = false;
        this.dataBkp = [...res];
        this.totalPages = parseInt(Math.ceil(res.length / this.limit));
        this.data = this.paginate([...res], this.limit, this.page);
      });
    },
    handleSort(item) {
      this.sort = !this.sort;
      this.dataSearch = [...this.dataBkp];
      if (item == "Nome da campanha") {
        this.dataSearch.sort((a, b) => this.sortFn(a.name, b.name));
      }

      if (item == "Falecido") {
        this.dataSearch.sort((a, b) => this.sortFn(a.isDead, b.isDead));
      }
      if (item == "Tipo") {
        this.dataSearch.sort((a, b) => this.sortFn(a.type, b.type));
      }
      if (item == "Gênero") {
        this.dataSearch.sort((a, b) => this.sortFn(a.gender, b.gender));
      }
      if (item == "Idade") {
        this.dataSearch.sort((a, b) => this.sortFn(a.age, b.age));
      }
      if (item == "Documento") {
        this.dataSearch.sort((a, b) => this.sortFn(a.document, b.document));
      }
      this.alterPage(1);
    },
    sortFn(a, b) {
      if (this.sort) return a > b ? 1 : b > a ? -1 : 0;
      return a < b ? 1 : b < a ? -1 : 0;
    },
    handleSubmit() {
      this.isLoading = true;
      let identifiers = this.collection.reduce((acc, element) => {
        if (!acc.includes(element.selectedNumber.value)) {
          acc.push(element.selectedNumber.value);
        }
        return acc;
      }, []);

      let template_ids = this.collection.reduce((acc, element) => {
        const template_id = this.templatesByIdentifier[
          element.selectedNumber.value
        ].find((foo) => foo.name == element.selectedName)._id;
        if (!acc.includes(template_id)) {
          acc.push(template_id);
        }
        return acc;
      }, []);

      // console.log(JSON.parse(JSON.stringify(this.templatesByIdentifier)));
      // console.log(JSON.parse(JSON.stringify(this.collection)));
      const data = {
        name: this.name,
        identifiers,
        template_ids,
      };

      createTemplateCollection(data)
        .then((data) => {
          console.warn(data);
          this.showModalAdd = false;
          this.$toast.open({
            position: "top",
            message: "Campanha cadastrada com sucesso!",
            type: "success",
          });
        })
        .catch((error) => {
          console.table(error);
          this.$toast.open({
            position: "top",
            message:
              "Ops, aconteceu um erro ao criar sua campanha! Tente mais tarde!",
            type: "error",
          });
          this.$toast.open({
            position: "top",
            message: "Verifique se o nome da sua campanha já foi criado!",
            type: "error",
          });
          this.showModalAdd = false;
        })
        .finally(() => {
          this.isLoading = false;
        });

      // this.isLoading = "Gerando campanha";
      // let identificador = this.credentials.find(
      //   (credential) => credential.numero_whatsapp === this.selectedNumber
      // ).identificador;
      // let templateId = this.templatesData.find(
      //   (template) => template.name === this.selectedTemplateName
      // )._id;

      // createCampaigns(identificador, templateId, data)
      //   .then((data) => {
      //     const url = window.URL.createObjectURL(new Blob([data])); // you can mention a type if you wish
      //     const link = document.createElement("a");
      //     link.href = url;
      //     link.setAttribute("download", `modelo-${this.name}.xlsx`); //this is the name with which the file will be downloaded
      //     link.click();
      //     // no need to append link as child to body.
      //     setTimeout(() => window.URL.revokeObjectURL(url), 0);
      //     this.renderComponent();
      //     this.showModalAdd = false;
      //     this.$toast.open({
      //       position: "top",
      //       message: "Campanha cadastrada com sucesso!",
      //       type: "success",
      //     });
      //   })
      //   .catch(() => {
      //     this.$toast.open({
      //       position: "top",
      //       message:
      //         "Ops, aconteceu um erro ao criar sua campanha! Tente mais tarde!",
      //       type: "error",
      //     });
      //     this.showModalAdd = false;
      //   })
      //   .finally(() => {
      //     this.isLoading = false;
      //   });
    },

    handleUpdate() {
      const data = {
        id: this.itemEdit.id,
        name: this.itemEdit.name,
        start: this.itemEdit.start_at,
        end: this.itemEdit.finish_at,
      };

      const isEqual =
        JSON.stringify(this.itemEdit) === JSON.stringify(this.itemToUpdate);
      if (!isEqual) {
        updateCampaigns(data)
          .then(() => {
            getCampaigns().then((res) => {
              this.data = res;
            });
            this.showModalEdit = false;
            this.$toast.open({
              position: "top",
              message: "Campanha editada com sucesso!",
              type: "success",
            });
            return;
          })
          .catch(() => {
            this.$toast.open({
              position: "top",
              message:
                "Ops, aconteceu um erro ao editar sua campanha! Tente mais tarde!",
              type: "error",
            });
            this.showModalEdit = false;
            return;
          });
      } else {
        this.$toast.open({
          position: "top",
          message: "Campos Inválidos ou totalmente iguais aos já existente!",
          type: "error",
        });
        return;
      }
    },
    clearData() {
      this.name = "";
      this.startDate = new Date();
      this.linkCampaign = "";
      this.candidates = 1;
    },
    alterPage(n) {
      this.page = n;
      const data = this.dataSearch.length > 0 ? this.dataSearch : this.dataBkp;
      this.data = this.paginate(data, this.limit, this.page);
    },
    paginate(array, page_size, page_number) {
      // human-readable page numbers usually start with 1, so we reduce 1 in the first argument
      return array.slice(
        (page_number - 1) * page_size,
        page_number * page_size
      );
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
button {
  font-size: 0.85em;
  font-weight: bold !important;
}
b {
  font-weight: bold !important;
}
.whatsapp-container {
  padding: 1em;
  margin: 1em;
  height: 100%;
  width: 100%;
}
.whatsapp-body {
  display: flex;
  justify-content: center;
  align-content: center;
  padding: 1em;
  border-radius: 10px;
  color: #606060;
  background-color: #fff;
}
.whatsapp-body .whatsapp-message-body {
  white-space: pre-wrap;
}
.whatsapp-buttons-group {
  display: flex;
  flex-wrap: wrap;
  padding: 1.4em 0;
  gap: 0.8em;
}
.whatsapp-buttons-group .whatsapp-button {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 40%;
  background-color: #fff;
  padding: 1em;
  border-radius: 10px;
  font-size: 14px;
  color: #46baea;
}
.custom-absolute-positioning {
  right: 0;
  left: 0;
  top: 0;
  bottom: 0;
  margin: auto;
}
.d-flex.groupbuttons {
  gap: 3em;
}
.size-badge {
  min-width: 80px;
}
.card.card-cascade .view.gradient-card-header {
  padding: 1rem 1rem;
  text-align: center;
}
.card.card-cascade h3,
.card.card-cascade h4 {
  margin-bottom: 0;
}
.text-size {
  font-size: 11pt;
}
.bg-color {
  background: #588cb8;
}
.text-btn {
  font-weight: bold;
  text-transform: capitalize;
  font-size: 10pt;
}
.first-text {
  color: #464e5f;
}
.custom-grey {
  background-color: rgba(0, 0, 0, 0.05);
}
.modal-line {
  display: flex;
  justify-content: space-between;
}

.input-wrapper {
  display: flex;
  flex-direction: column;
  width: 48%;
}
.row-label {
  display: flex !important;
  flex-direction: row;
  gap: 28%;
}
.v-select {
  margin-bottom: 0.5em;
}
</style>

<style>
.custom-grey {
  background-color: rgba(0, 0, 0, 0.05);
}
</style>
